import { Observable } from 'rxjs';

/**
 * Creates an Observable from a Server-Sent Events connection.
 * Automatically closes the EventSource on unsubscribe (teardown).
 *
 * Listens for a single named event type (e.g., "status") and emits parsed JSON data.
 * EventSource handles reconnection natively on transient network errors.
 */
export function fromSse<T>(url: string, eventType: string): Observable<T> {
  return new Observable<T>((subscriber) => {
    const eventSource = new EventSource(url);

    eventSource.addEventListener(eventType, (event: MessageEvent<string>) => {
      try {
        subscriber.next(JSON.parse(event.data) as T);
      } catch {
        subscriber.error(new Error(`Failed to parse SSE data: ${event.data}`));
      }
    });

    eventSource.onerror = () => {
      if (eventSource.readyState === EventSource.CLOSED) {
        subscriber.error(new Error('SSE connection closed'));
      }
    };

    return () => {
      eventSource.close();
    };
  });
}
